export enum EAnnouncementType {
  INFO = 'info',
  WARNING = 'warning',
  ALERT = 'alert',
}

export enum EAnnouncementDisplayType {
  TOAST = 'toast',
  MODAL = 'modal',
}

export interface IAnnouncement {
  id: number;
  message: string;
  type: EAnnouncementType;
  displayType: EAnnouncementDisplayType;
  durationSeconds: number | null;
  snoozeMinutes: number | null;
}

export type TAnnouncementSnoozeStorage = Record<number, string>;
